export default __webpack_public_path__ + "static/media/IQ.9892f945.PNG";